module.exports = __webpack_public_path__ + "static/media/Demographic.1d6b6048.svg";